export default __webpack_public_path__ + "static/media/baner-top_przypon_2027.5c6f7741.jpg";